import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State, whiteLabelingFeatureKey } from '../reducers/white-labeling.reducer';

export const selectWhiteLabelingFeature = createFeatureSelector<State>(whiteLabelingFeatureKey);

export const selectColors = createSelector(selectWhiteLabelingFeature, (state: State) => state.colors);

export const selectLogoUrl = createSelector(selectWhiteLabelingFeature, (state: State) => state.logoUrl);
